<template>
    <solid-box :title="moduleName">
        <table-info :columns="columns" :table-data="tableData" />
    </solid-box>
</template>

<script>
import TableInfo from '@/components/TableInfo'
import * as screenAPI from '@/api/screen'
import eventHub from '@/utils/eventHub'
import SolidBox from '@/components/SolidBox'
// import env from '@/config/env'

/**
 * 挂牌项目
 */
export default {
    components: {
        TableInfo,
        SolidBox
    },
    props: {
        moduleName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            columns: [
                { title: '项目名称', field: 'projectName', width: '36%' },
                { title: '面积/数量', field: 'acreage', width: '16%' },
                { title: '公告价格', field: 'price', type: 'emphasize' },
                { title: '挂牌时间', field: 'time' }
            ],
            tableData: []
        }
    },
    mounted() {
        // levelChange 地图 县、区  竞拍项目和预挂牌项目列表不展示 地区字段
        eventHub.$on('levelChange', (level) => {
            if (level > 2) {
                this.columns = [
                    { title: '项目名称', field: 'projectName', width: '36%' },
                    { title: '面积/数量', field: 'acreage', width: '16%' },
                    { title: '公告价格', field: 'price', type: 'emphasize' },
                    { title: '挂牌时间', field: 'time' }
                ]
            } else {
                this.columns = [
                    { title: '项目名称', field: 'projectName', width: '36%' },
                    { title: '地区', field: 'showArea', width: '16%' },
                    { title: '面积/数量', field: 'acreage', width: '16%' },
                    { title: '公告价格', field: 'price', type: 'emphasize' },
                    { title: '挂牌时间', field: 'time' }
                ]

                // 2023-05-26 全国大屏特殊处理
                if (!+this.$route.params.id) {
                    this.columns = this.columns
                        .slice(0, 1)
                        .concat(this.columns.slice(2))
                }
            }
        })
        eventHub.$on('areaChange', () => {
            this.tableData = []
            this.getProjectList()
        })
        this.getProjectList()
    },
    methods: {
        async getProjectList() {
            const params = {
                resource: this.$route.name === 'haiken' ? 2 : undefined,
                siteId:
                    this.$route.params.id === 'zhongguo'
                        ? 0
                        : this.$route.params.id,
                locId: this.$getLocId(),
                listType: 1 // 1挂牌 2竞拍
            }

            const response = await screenAPI.getProjectList(params)
            if (response && response.data && response.data.length) {
                this.tableData = response.data
                for (let i = 0; i < this.tableData.length; i++) {
                    this.tableData[i].acreage =
                        this.tableData[i].acreage +
                        (this.tableData[i].acreageUnit || '')
                    this.tableData[i].price =
                        this.tableData[i].price +
                        (this.tableData[i].priceUnit || '')
                }
                // 2022-07-27 针对湖南线上大屏做的特殊处理
                // let data = []
                // if (this.$route.params.id === env.HNLOCID) {
                //     for (let i = 0; i < this.tableData.length; i++) {
                //         if (this.tableData[i].time.includes('2023-')) {
                //             data.push(this.tableData[i])
                //         }
                //     }
                //     this.tableData = data
                // }
            }
        }
    }
}
</script>

<style></style>
